module.exports = __webpack_public_path__ + "assets/img/icon-gftj.2b69ad7f.png";